import { React, useState, useEffect, useContext } from "react";
import Button from "@mui/material/Button";
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid';
import GridNoRow from '../../../../common/GridNoRow';
import axios from "axios";
import Swal from "sweetalert2";
import StockInfoModal from "../../../../modal/PC/stock/StockInfoModal";
import styled from "styled-components";
import Select from 'react-select';
import { AppContext } from '../../../../AppStore';
import Moment from 'moment';
import { useNavigate, useLocation } from "react-router-dom";
import AssignmentIcon from '@mui/icons-material/Assignment';
import { Chart } from "react-google-charts";

const StockInfo = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const appStore = useContext(AppContext);
    const [MenuID, setMenuID] = useState(0);
    const [MenuName, setMenuName] = useState('');
    const [MenuUpdateExistYN, setMenuUpdateExistYN] = useState('N');
    const [MenuDeleteExistYN, setMenuDeleteExistYN] = useState('N');
    const [MenuUpdateYN, setMenuUpdateYN] = useState('N');
    const [MenuDeleteYN, setMenuDeleteYN] = useState('N');
    const [rows, setRows] = useState([]);
    const [columns, setColumns] = useState([]);
    const [statusOption, setStatusOption] = useState([]);
    const [keyword, setKeyword] = useState({
        type:0,
        division:0,
        search:''
    });
    const [recentReady, setRecentReady] = useState('N');
    const [recentMonthReady, setRecentMonthReady] = useState('N');
    const [recentData, setRecentData] = useState([]);
    const [recentMonthData, setRecentMonthData] = useState([]);
    const recentOptions = {
        /*
        title: "최근재고현황",
        titleTextStyle: {
            fontSize: 20, // 제목의 폰트 크기 설정
            //color: 'blue', // 제목의 폰트 색상 설정
            fontName: 'Arial', // 제목의 폰트 설정 (선택사항)
        },
        */
        legend: 'none'
    };
    const recentMonthOptions = {
        /*
        title: "월별재고현황",
        titleTextStyle: {
            fontSize: 20, // 제목의 폰트 크기 설정
            //color: 'blue', // 제목의 폰트 색상 설정
            fontName: 'Arial', // 제목의 폰트 설정 (선택사항)
        },
        */
        legend: 'none'
    };
    const [typeOption, setTypeOption] = useState([]);
    const [divisionOption, setDivisionOption] = useState([]);
    const [isModalOpen, setModalOpen] = useState(false);
    const [modalTitle, setModalTitle] = useState('');
    const [selectItemID, setSelectItemID] = useState('');
    const [selectItemTypeName, setSelectItemTypeName] = useState('');
    const [selectItemDivisionName, setSelectItemDivisionName] = useState('');
    const [selectItemName, setSelectItemName] = useState('');
    const [selectItemSpec, setSelectItemSpec] = useState('');
    
    // Grid정의
    const handleSetting = () => {
        setColumns([
            {
                field: 'viewer',
                headerName: '상세',
                width: 55,
                type:'actions',
                disableClickEventBubbling: true,
                getActions: (params) => [
                    <GridActionsCellItem icon={<AssignmentIcon color={"primary"} />} onClick={() => {DetailClick(params)}} label="Viewer" />
                ],
                headerAlign: 'center', 
                align:'center'
            },
            { field: 'id', headerName: 'item_id', width: 0, headerAlign: 'center' },
            { field: 'company_id', headerName: 'company_id', width: 0, headerAlign: 'center' },
            { field: 'item_version_seq', headerName: 'item_version_seq', width: 0, headerAlign: 'center' },
            { field: 'item_name', headerName: '품목명', width: 150, headerAlign: 'center', align:'left' },
            { field: 'item_type_name', headerName: '유형', width: 70, headerAlign: 'center', align:'center' },
            { field: 'item_division_name', headerName: '분류', width: 90, headerAlign: 'center', align:'center' },
            { field: 'item_spec', headerName: '규격', width: 200, headerAlign: 'center', align:'left' },
            { field: 'item_width', headerName: 'item_width', width: 0, headerAlign: 'center', align:'center' },
            { field: 'item_depth', headerName: 'item_depth', width: 0, headerAlign: 'center', align:'center' },
            { field: 'item_height', headerName: 'item_height', width: 0, headerAlign: 'center', align:'center' },
            { field: 'item_total_safe_stock_count', headerName: 'item_total_safe_stock_count', width: 0, headerAlign: 'center', align:'right' },
            { field: 'dp_item_total_safe_stock_count', headerName: '안전재고', width: 90, headerAlign: 'center', align:'right' },
            { field: 'stock', headerName: 'stock', width: 0, headerAlign: 'center', align:'right' },
            { field: 'dp_stock', headerName: '재고', width: 85, headerAlign: 'center', align:'right' },
            { field: 'use_stock', headerName: 'use_stock', width: 0, headerAlign: 'center', align:'right' },
            { field: 'dp_use_stock', headerName: '사용가능재고', width: 120, headerAlign: 'center', align:'right' }
        ]);
    }

    const [columnVisibilityModel, setColumnVisibilityModel] = useState({
        viewer: true,
        id: false,
        company_id: false,
        item_version_seq: false,
        item_type_name: true,
        item_division_name: true,
        item_name: true,
        item_spec: true,
        item_width: false,
        item_depth: false,
        item_height: false,
        dp_item_total_safe_stock_count: true,
        item_total_safe_stock_count: false,
        dp_stock: true,
        stock: false,
        dp_use_stock: true,
        use_stock: false
    });

    useEffect(() => {
        const accessList = JSON.parse(localStorage.getItem("nav"));
        
        if (Array.isArray(accessList) && accessList.filter(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).length > 0) {
            setMenuID(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_id);
            setMenuName(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_name);
            setMenuUpdateExistYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_update_exist_yn);
            setMenuDeleteExistYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_delete_exist_yn);
            setMenuUpdateYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_update_yn);
            setMenuDeleteYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_delete_yn);
        }else{
            Swal.fire({
                title: '<p style="color:red">접근 권한 오류</p>',
                text: '화면에 접근 권한이 없습니다.',
                confirmButtonText: '확인',
                confirmButtonColor: '#7066e0',
                timer:5000,
                timerProgressBar: true
            }).then((value) => {
                return navigate(-1);
            });
        }
    }, []);

    useEffect(() => {
        if(MenuID !== 0 && statusOption != []){
            handleView();
        }
    }, [keyword.type, keyword.division])

    useEffect(() => {
        if(String(MenuID) !== String(0) && MenuID != null){
            handleSetting();
            handleInitSelect();
            handleView();
        }
    }, [MenuID]);

    useEffect(() => {
        setRecentData([]);
        setRecentReady('N');
        setRecentMonthData([]);
        setRecentMonthReady('N');
        // 아래의 변수가 변경되면 실행된다. -> 코드 Grid 선택이 바뀌면 조회됨.
        if(selectItemID !== ''){
            axios.get('/api/p/StockInfo/RecentList',
                {
                    params : {
                        item_id: selectItemID
                    }
                }
            )
            .then((response) => {
                var newRows = [['일자', '재고', '사용가능재고']];
                if(response.status === 200){
                    for(var i=0; i<(response.data).length; i++){
                        newRows.push([(response.data)[i].date, (response.data)[i].recent_stock, (response.data)[i].recent_use_stock]);
                    }
                    if(newRows.length > 1){
                        setRecentData(newRows);
                        setRecentReady('Y');
                    }
                }else{
                    appStore.capture();
                }
            })
            .catch((error) => {
                appStore.capture();
            });


            axios.get('/api/p/StockInfo/RecentMonthList',
                {
                    params : {
                        item_id: selectItemID
                    }
                }
            )
            .then((response) => {
                var newMonthRows = [['년월', '재고', '사용가능재고']];
                if(response.status === 200){
                    for(var i=0; i<(response.data).length; i++){
                        newMonthRows.push([(response.data)[i].dp_month_date, (response.data)[i].recent_stock, (response.data)[i].recent_use_stock]);
                    }
                    if(newMonthRows.length > 1){
                        setRecentMonthData(newMonthRows);
                        setRecentMonthReady('Y');
                    }
                }else{
                    appStore.capture();
                }
            })
            .catch((error) => {
                appStore.capture();
            });
        }
    }, [selectItemID])

    // Grid 데이터 조회
    const handleView = () => {
        
        axios.get('/api/p/StockInfo/List',
            {
            params : {
                type: keyword.type,
                division: keyword.division,
                search: keyword.search
            }
        },
        { withCredentials: true }
        )
        .then((response) => {
            const array = response.data.map((item, index) => ({
                id: item.item_id,
                company_id: item.company_id,
                item_version_seq: item.item_version_seq,
                item_type_name: item.item_type_name,
                item_division_name: item.item_division_name,
                item_name: item.item_name,
                item_spec: appStore.ITEM_FULL_SPEC_MAKE(item.item_spec, item.item_width, item.item_depth, item.item_height),
                item_width: item.item_width,
                item_depth: item.item_depth,
                item_height: item.item_height,
                item_total_safe_stock_count: item.item_total_safe_stock_count,
                dp_item_total_safe_stock_count: item.dp_item_total_safe_stock_count,
                stock: item.stock,
                dp_stock: item.dp_stock,
                use_stock: item.use_stock,
                dp_use_stock: item.dp_use_stock
            }));
            setRows(array);
        })
        .catch((error) => {
        });

    }

    const handleInitSelect = () => {
        // 품목유통, 품목분류, 단위, 통화단위, 유통기한유형
        axios.get('/api/Common/CodeDetailList')
        .then((response) => { 

            var type_array = [];
            var division_array = [];
            for(let i=0; i<(response.data).length; i++){

                if((response.data)[i].code_id === '0014'){
                    type_array.push({ value: (response.data)[i].code_detail_seq, label: (response.data)[i].code_detail_name });
                }else if((response.data)[i].code_id === '0015'){
                    division_array.push({ value: (response.data)[i].code_detail_seq, label: (response.data)[i].code_detail_name });
                }

            }

            type_array.unshift({ value: 0, label : '유형'});
            division_array.unshift({ value: 0, label : '분류'});

            setTypeOption(type_array);
            setDivisionOption(division_array);
        })
        .catch((error) => {
            console.log(error);
        });
    }

    const handleInit = () => {
        setKeyword({
            type:0,
            division:0,
            search:''
        })
        
        // Hide컬럼 숨기기.
        setColumnVisibilityModel({
            viewer: true,
            id: false,
            company_id: false,
            item_version_seq: false,
            item_type_name: true,
            item_division_name: true,
            item_name: true,
            item_spec: true,
            item_width: false,
            item_depth: false,
            item_height: false,
            dp_item_total_safe_stock_count: true,
            item_total_safe_stock_count: false,
            dp_stock: true,
            stock: false,
            dp_use_stock: true,
            use_stock: false
        });
    };
    
    const onSelectChange = (type, value) => {
        const nextKeyword = {
            ...keyword,
            [type] : value
        };
        setKeyword(nextKeyword);
    };

    const onChange = (e)=>{
        const {name, value} = e.target;
        const nextKeyword = {
            ...keyword,
            [name]: value, 
        };
        setKeyword(nextKeyword);
    };

    const onSubmitSearch = (e) => {
        //입력 검색어는 Enter로 조회.
        if (e.key === "Enter") {
          handleView();
        }
    };
    
    const DetailClick = (object) => {
        setModalOpen(true);
        setModalTitle('재고 상세');
        setSelectItemID(object.row.id);
        setSelectItemTypeName(object.row.item_type_name);
        setSelectItemDivisionName(object.row.item_division_name);
        setSelectItemName(object.row.item_name);
        setSelectItemSpec(object.row.item_spec);
    };

    const handleExcel = () => {
        var filename = '재고조회'
        axios.get('/api/p/StockInfo/Excel',
        {   
            params : { type: keyword.type, division: keyword.division, search: keyword.search, file_name: filename },
            responseType:'blob'
        },
        { withCredentials: true })
        .then(function (response) {
            
            if(response.status === 200){
                filename = filename + ' ' + appStore.YYYY_MM_DD_HH_MI_SS();
                const link = document.createElement('a');
                link.href = URL.createObjectURL(response.data);
                link.setAttribute('download', filename+'.xlsx');
                document.body.appendChild(link);
                link.click();
            }
        })
        .catch(function (error) {
            appStore.capture();
        })
    };
    
    return (
        <div style={ { width:'100%', display: String(MenuID) === String(0) ? 'hidden' : 'block' } }>
            <div className="menubox">
                <div className="menu-action">
                    <div className="menu-title">{ MenuName }</div>
                    <div className="menu-button">
                    <Button 
                        onClick={ handleExcel }
                        className="btn-p"
                        sx={{  
                            m: 1, 
                            fontSize: 15, 
                            color: "white", 
                            borderColor: "#00AC47", 
                            backgroundColor: "#00AC47",
                            ":hover": { boxShadow: "2px 2px 2px #00AC47" , backgroundColor: "#00AC47", borderColor: "#00AC47"}
                        }} 
                        variant="outlined">
                        엑셀
                    </Button>
                    <Button 
                        onClick={ handleInit }
                        className="btn-p"
                        sx={{  
                            m: 1, 
                            fontSize: 15, 
                            color: "white", 
                            borderColor: "black", 
                            backgroundColor: "black",
                            ":hover": { boxShadow: "2px 2px 2px black" , backgroundColor: "black", borderColor: "black"}
                        }} 
                        variant="outlined">
                        초기화
                    </Button>
                    <Button 
                        onClick={ handleView }
                        className="btn-p"
                        sx={{  
                            m: 1, 
                            fontSize: 15, 
                            color: "white", 
                            borderColor: "#3D63AE", 
                            backgroundColor: "#3D63AE",
                            ":hover": { boxShadow: "2px 2px 2px #3D63AE" , backgroundColor: "#3D63AE", borderColor: "#3D63AE"}
                        }} 
                        variant="outlined">
                        조회
                    </Button>
                    </div>
                </div>
                <div className="menu-keyword">
                    <div className="menu-keyword-sub">
                        <div className="menu-keyword-sub-title">
                            유형
                        </div>
                        <div className="menu-keyword-sub-keyword">
                            <Select className="menu-keyword-sub-keyword-select" placeholder="유형" onChange={(e) => onSelectChange('type',e.value)} value={typeOption.filter(function (option) { return option.value === keyword.type;  })} options={typeOption} noOptionsMessage={() => "조회되는 항목 없음"} />
                        </div>
                    </div>
                    <div className="menu-keyword-sub">
                        <div className="menu-keyword-sub-title">
                            분류
                        </div>
                        <div className="menu-keyword-sub-keyword">
                            <Select className="menu-keyword-sub-keyword-select" placeholder="분류" onChange={(e) => onSelectChange('division',e.value)} value={divisionOption.filter(function (option) { return option.value === keyword.division;  })} options={divisionOption} noOptionsMessage={() => "조회되는 항목 없음"} />
                        </div>
                    </div>
                    <div className="menu-keyword-sub">
                        <div className="menu-keyword-sub-keyword" style={ { maxWidth: '300px' } }>
                            <input type="text" placeholder="검색" value={keyword.search} name="search" onChange={(e) => onChange(e) } onKeyPress={onSubmitSearch} autoComplete="off" />
                        </div>
                    </div>
                </div>
            </div>
            <div className="grid">
                <div style={ {  width: '100%' } }>
                    <div className="grid_sub" style={ {  width: '900px', float: 'left', fontSize: '17px' } }>
                        <DataGrid
                            className="grid_main"
                            rows={rows}
                            columns={columns}
                            slots={{
                                noRowsOverlay: GridNoRow,
                            }}
                            columnVisibilityModel={columnVisibilityModel}
                            onRowSelectionModelChange={(newSelectedIds) => {
                                setSelectItemID(newSelectedIds[0]);
                            }}
                            selectedIds={selectItemID}
                            AlternatingRowBackground="LavenderBlush"
                            rowsPerPageOptions={[20, 50, 100]}
                        />
                        {isModalOpen && (
                            <StockInfoModal
                                onClose={() => {
                                    setModalOpen(false);
                                }}
                                title={modalTitle}
                                id={selectItemID}
                                item_type_name={selectItemTypeName}
                                item_division_name={selectItemDivisionName}
                                item_name={selectItemName}
                                item_spec={selectItemSpec}
                            />
                        )}
                    </div>
                    <div className="grid_sub" style={ { width: 'calc(100% - 910px)', float: 'right' } }>
                        
                        {recentReady === 'Y'?
                            <>
                            <h3 style={ { margin: '0px', textAlign: 'center', fontSize: '24px' } }>최근재고현황</h3>
                            <Chart chartType="LineChart" width="calc(100% - 10px)" height="calc((100vh - 375px)/2)" data={recentData} options={recentOptions} />
                            </>
                            :
                            <>
                            <h3 style={ { margin: '0px', textAlign: 'center', fontSize: '24px', height:"calc((100vh - 304px)/2)" } }>최근재고현황</h3>
                            </>}
                        <br/>
                        
                        {recentMonthReady === 'Y'? 
                            <>
                            <h3 style={ { margin: '0px', textAlign: 'center', fontSize: '24px' } }>월별재고현황</h3>
                            <Chart chartType="LineChart" width="calc(100% - 10px)" height="calc((100vh - 375px)/2)" data={recentMonthData} options={recentMonthOptions} />
                            </>
                            :
                            <>
                            <h3 style={ { margin: '0px', textAlign: 'center', fontSize: '24px', height:"calc((100vh - 304px)/2)" } }>월별재고현황</h3>
                            </>
                            }
                    </div>
                </div>
            </div>
        </div>
    )
}

const AppWrap = styled.div`
  text-align: center;
  margin: 50px auto;
`;

export default StockInfo;